<template>
  <aside v-if="!caixa.ultimoCaixa">
    <Cards />
    <div class="saldo">
      <span class="w-75">Saldo total</span>
      <input id="custa_valor"
             v-money="money"
             class="w-100"
             :value="cxSaldo.pedidos.saldoTotal"
             disabled
             name="custa_ipesp"
             size="sm"
             trim>
    </div>
  </aside>
</template>

<script>
  // Components
  import Cards  from "./Cards/Cards"
  import BotaoImprimir from "./BotaoImprimir/BotaoImprimir"

  // Services
  import { VMoney } from 'v-money'

  export default {
    name: "Orcamentos",
    directives: {
      money: VMoney
    },
    components: {
      Cards,
      BotaoImprimir,
    },
    data () {
      return {
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
    computed: {
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      },
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      caixa () {
        return this.$store.state.frenteCaixa.caixa
      }
    },
    async created () {
  
    },
    methods: {

    }
  }
</script>

<style scoped>
  aside {
    padding-left: 15px;
    margin-top: 15px;
    border-left: 3px solid #074f7f;
    margin-left: 15px;
    width: 95%;
  }  
  .saldo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 22px;
    color: black;
    margin: 30px 0

  }
  .saldo input {
    text-align: right;
    color: black;
    font-size: 22px;
    font-weight: bold;
  }
</style>